import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'
import Link, { withPrefix } from 'gatsby-link'
import {
  Button,
  Icon,
  Grid,
  Label,
  Divider,
  Header,
  Message,
  Dropdown,
} from 'semantic-ui-react'
import { Form } from 'formsy-semantic-ui-react'
import moment from 'moment'
import pluralize from 'pluralize'
import AirlineLogo from './AirlineLogo'
// import StripeCCForm from './StripeCCForm'
import Typed from 'react-typed'
import StripePaymentRequestButton from './StripePaymentRequestButton'
import { Share } from 'react-twitter-widgets'
// import Paypal from 'react-paypal-express-checkout'
import cn from 'clsx'

const DateTimeAirport = ({ time, airport, ...props }) => {
  const _time = moment.unix(time).utc()
  return (
    <React.Fragment>
      {_time.format('MMM D')}
      <br />
      {_time.format('h:mma')}
      <br />
      <b>{airport}</b> <br />
    </React.Fragment>
  )
}

const DurationAndStops = ({ title, date, stopsQty, duration }) => {
  return (
    <Label basic size='small' className='flightDurationAndStops' title={title}>
      <Icon name='plane' />
      {moment(date).format('MMM D') + '  '}
      <Icon name='time' />
      {duration}
    </Label>
  )
}

const RouteDetails = ({ route, ...props }) => {
  const [visible, setVisible] = useState(false)
  if (visible) {
    return (
      <div className='RouteDetails'>
        <a onClick={_ => setVisible(false)}>Hide Details</a>
        {route.map((r, key) => (
          <div key={key}>
            {moment.unix(r.dTimeUTC).format('MMM D: h:mma')} {r.cityFrom} ({r.flyFrom})
            {' → '}
            {moment.unix(r.aTimeUTC).format('h:mma')} {r.cityTo} ({r.flyTo})
          </div>
        ))}
      </div>
    )
  } else {
    return (
      <div className='RouteDetails'>
        <a onClick={_ => setVisible(true)}>Show Details</a>
      </div>
    )
  }
}

const BuyWithCryptoButton = ({ onClick, size, totalPrice = 500, loading }) => (
  <React.Fragment>
    {size === 'large' ? (
      <Form.Button
        onClick={onClick}
        color='green'
        size='huge'
        className='rounded'
        fluid
        loading={loading}>
        {'Buy with '}
        <em>
          <Icon name='bitcoin' />
          <Typed
            strings={['Bitcoin', 'USDT', 'Crypto']}
            typeSpeed={30}
            backSpeed={50}
            showCursor={false}
            smartBackspace={true}
            backDelay={2000}
            loop
          />
        </em>
        {/* <span className='price'>${totalPrice / 100}</span> */}
      </Form.Button>
    ) : (
      <button className='buy-with-crypto' onClick={onClick}>
        {loading ? (
          'Processing…'
        ) : (
          <React.Fragment>
            Buy with <Icon name='bitcoin' color='orange' />
            <i className='black text'>Bitcoin</i>
          </React.Fragment>
        )}
      </button>
    )}
  </React.Fragment>
)

const BuyWithCardButton = ({ onClick, size, totalPrice, loading }) => {
  if (size === 'small') {
    return (
      <Form.Button
        onClick={onClick}
        size='tiny'
        className='buy-with-card rounded'
        fluid
        loading={loading}
        style={{
          background: 'white',
          border: '2px solid #21BA45',
          fontSize: 12,
          color: 'black',
        }}>
        Pay with <Icon name='credit card small' style={{ margin: '0px 2px 0px' }} />{' '}
        <b>Credit Card</b>
      </Form.Button>
    )
  } else {
    return (
      <Form.Button
        onClick={onClick}
        color='green'
        size='huge'
        className='rounded'
        fluid
        loading={loading}>
        Buy now <span className='price'>${totalPrice / 100}</span>
      </Form.Button>
    )
  }
}

@inject('FlightStore')
@inject('UserStore')
@observer
class FlightPreview extends React.Component {
  scrollToResult(offset = 20) {
    setTimeout(() => {
      const { offsetTop } = ReactDOM.findDOMNode(this)
      window.scrollTo({
        top: offsetTop - offset,
        behavior: 'smooth',
      })
    }, 100)
  }
  select() {
    this.props.FlightStore.selectFlight(this.props.id)
    this.scrollToResult()
  }
  unselect() {
    this.props.FlightStore.selectFlight(undefined)
  }

  render() {
    const {
      selectedFlight,
      totalPrice,
      when,
      returnDate,
      DATE_FORMAT,
    } = this.props.FlightStore
    const {
      cityFrom,
      cityTo,
      flyFrom,
      flyTo,
      airlines,
      price,
      fly_duration,
      return_duration,
      dTime,
      aTime,
      id,
      route: { length: routeLength },
    } = this.props
    const isSelected = id === selectedFlight
    const selectedClass = isSelected ? ' selected ' : ''
    const stopsQty = routeLength - 1 - (Boolean(return_duration) ? 1 : 0)

    if (toJS(airlines)[0] === 'SQ' || toJS(airlines)[1] === 'SQ') {
      return null // Hiding Singapore Airlines
    }

    if (toJS(airlines)[0] === 'MI' || toJS(airlines)[1] === 'MI') {
      return null // Hiding SilkAir
    }

    return (
      <Grid className={'FlightPreview' + selectedClass} columns={3} stackable>
        <Grid.Row verticalAlign='top'>
          <Grid.Column textAlign='center' width={3}>
            {airlines.map(code => (
              <AirlineLogo key={code} fluid rounded code={code} />
            ))}
          </Grid.Column>

          <Grid.Column width={8}>
            <Grid columns={3}>
              <Grid.Column width={7}>
                <DateTimeAirport airport={flyFrom} time={dTime} />
              </Grid.Column>
              <Grid.Column textAlign='left' width={1} style={{ paddingTop: '2em' }}>
                →
              </Grid.Column>
              <Grid.Column width={7}>
                <DateTimeAirport airport={flyTo} time={aTime} />
              </Grid.Column>
            </Grid>
            <DurationAndStops
              date={when}
              duration={fly_duration}
              stopsQty={stopsQty}
              title='Departure'
            />
            {return_duration && (
              <DurationAndStops
                date={returnDate}
                duration={return_duration}
                stopsQty={stopsQty - 1}
                title='Return'
              />
            )}
            {stopsQty > 0 && (
              <Label
                basic
                size='small'
                className='flightDurationAndStops'
                content={pluralize('stop', stopsQty, true)}
              />
            )}
          </Grid.Column>

          <Grid.Column floated='right' width={4}>
            <div className='priceSection'>
              <strike>${price}</strike>
              <br />
              <small>
                <b>${totalPrice / 100}</b>
              </small>
              <br />
              {isSelected ? (
                <Button
                  size='small'
                  basic
                  className='rounded'
                  onClick={this.unselect.bind(this)}>
                  <Icon name='close' /> Close
                </Button>
              ) : (
                <Button
                  size='small'
                  color='purple'
                  className='rounded'
                  onClick={this.select.bind(this)}>
                  Select <Icon name='arrow right' />
                </Button>
              )}
            </div>
          </Grid.Column>
        </Grid.Row>
        <RouteDetails route={toJS(this.props.route)} />
        {this.renderSelected()}
      </Grid>
    )
  }

  renderSelected() {
    const { id, FlightStore } = this.props
    const {
      firstName,
      lastName,
      email,
      extraTravelers,
      travelersQty,
      selectedFlight,
      totalPrice,
      loading,
      err,
      ticketIssued,
      downloadLink,
      showPNR,
      togglePNR,
      paypalConfig,
      promoCode,
    } = FlightStore
    const {
      handleChange,
      generateTicket,
      buyV2,
      buyWithCrypto,
      buyWithPlisio,
      addTraveler,
      removeTraveler,
    } = FlightStore
    const { currencyCode, currencyOptions } = FlightStore
    const { user } = this.props.UserStore

    if (id === selectedFlight) {
      if (ticketIssued && ticketIssued.selectedFlight === selectedFlight) {
        this.scrollToResult(-30)
        return (
          <div>
            <Header as='h2' color='green'>
              Thank you!
            </Header>
            <ol>
              <li>
                <Button
                  className='underlined'
                  href={downloadLink}
                  target='_blank'
                  color='green'>
                  <Icon name='download' /> Download your PDF
                </Button>
              </li>
              <li>
                <Icon name='print' /> Print it
              </li>
              <li>
                <Icon name='plane' /> Present at check-in, if asked.
                <br />
                Read this{' '}
                <Link to='/faq' target='_blank'>
                  important information
                </Link>{' '}
                before you use this PDF.
              </li>
            </ol>
            <Divider />
            <small>
              <center>
                Tell your friends about ✈️ FakeFlightTickets.com !
                {/* <br />
                <a
                  href='https://www.trustpilot.com/review/fakeflighttickets.com'
                  target='_blank'
                  className='trustpilot-review-btn'>
                  Review us on{' '}
                  <img src='https://upload.wikimedia.org/wikipedia/commons/5/5c/Trustpilot_logo.png' />
                </a>
                <Share url='https://www.fakeflighttickets.com' /> */}
              </center>
            </small>
          </div>
        )
      }

      return (
        <Grid.Row className='details' columns={2}>
          <Grid.Column width={8}>
            <Form error={Boolean(err)}>
              <Form.Group className='travelers'>
                <Button.Group basic size='mini'>
                  <Button icon='minus' onClick={removeTraveler.bind(this, 'Adult')} />
                  <Button content={pluralize('Adult', travelersQty.adults, true)} />
                  <Button icon='plus' onClick={addTraveler.bind(this, 'Adult')} />
                </Button.Group>
                <Button.Group basic size='mini'>
                  <Button icon='minus' onClick={removeTraveler.bind(this, 'Child')} />
                  <Button content={pluralize('Children', travelersQty.children, true)} />
                  <Button icon='plus' onClick={addTraveler.bind(this, 'Child')} />
                </Button.Group>
              </Form.Group>
              <Form.Group>
                <Form.Input
                  name='firstName'
                  placeholder='Peter'
                  label='Your First Name'
                  onChange={handleChange}
                  defaultValue={firstName}
                  required={true}
                  width={8}
                />
                <Form.Input
                  name='lastName'
                  placeholder='Pan'
                  label='Last Name'
                  onChange={handleChange}
                  defaultValue={lastName}
                  required={true}
                  width={8}
                />
              </Form.Group>
              {extraTravelers.map(({ type, firstName, lastName }, i) => {
                return (
                  <Form.Group key={i}>
                    <Form.Input
                      name={`extraTravelers.${i}.firstName`}
                      placeholder='Peter'
                      label={`${type} ${i + 2}: First Name`}
                      defaultValue={firstName}
                      onChange={handleChange}
                      required={true}
                      width={8}
                    />
                    <Form.Input
                      name={`extraTravelers.${i}.lastName`}
                      placeholder='Pan'
                      label='Last Name'
                      defaultValue={lastName}
                      onChange={handleChange}
                      required={true}
                      width={8}
                    />
                  </Form.Group>
                )
              })}
              <Form.Input
                label='Email'
                placeholder='your@email.com'
                name='email'
                type='email'
                validations='isEmail'
                validationError='This is not an email'
                required
                defaultValue={email}
                onChange={handleChange}
              />

              {/*
            <small>
              <center>
                Oher payment methods are currently not available.<br/> Please come back later.
              </center>
            </small>*/}
              {/*<div className='field'>
              <StripeCCForm store={FlightStore} />
            </div>*/}
              {Boolean(user) && (
                <div className='balance' title='Balance you can spend'>
                  Balance: ${user.balance / 100}
                </div>
              )}
              <div
                style={{ margin: '0 0 1em' }}
                className={cn({ strikethrough: Boolean(promoCode) })}>
                <b>Total:</b> ${totalPrice / 100}
              </div>
              {/* <StripePaymentRequestButton total={totalPrice} /> */}
              {Boolean(promoCode) ? (
                <Form.Button
                  onClick={FlightStore.buy}
                  color='green'
                  size='huge'
                  className='rounded'
                  fluid
                  loading={loading}>
                  Generate
                </Form.Button>
              ) : (
                <React.Fragment>
                  <BuyWithCardButton
                    onClick={FlightStore.buy}
                    totalPrice={totalPrice}
                    loading={loading}
                    size='large'
                  />
                  {/* <BuyWithCryptoButton
                    onClick={buyWithPlisio}
                    totalPrice={totalPrice}
                    loading={loading}
                    size='large'
                  /> */}
                  <div id='stripeCheckoutEmbedded' />
                  <center className='btc-n-paypal'>
                    <small style={{ marginTop: '0px' }}>or</small>
                    <br />
                    {/* <span className='buy-with-paypal'>
                      <Paypal {...paypalConfig} total={totalPrice / 100} />
                    </span> */}

                    {/* <BuyWithCryptoButton
                      onClick={buyWithPlisio}
                      totalPrice={totalPrice}
                      loading={loading}
                      size='small'
                    /> */}

                    <button
                      className='buy-with-crypto cursor-pointer'
                      style={{ marginLeft: '1em' }}
                      // onClick={buyWithPlisio}>
                      onClick={FlightStore.buyWithCrypto}>
                      {loading ? (
                        'Processing…'
                      ) : (
                        <span>
                          Buy with <b className='black text'>Crypto </b>
                          <Icon name='bitcoin' color='orange' /> Bitcoin, ETH, SOL, USDT,
                          USDC …
                        </span>
                      )}
                    </button>
                    <span className='opacity-80 text-xs mt-1'>
                      Minimum $7 for crypto payments
                    </span>
                    {/* <BuyWithCardButton
                      onClick={buy}
                      totalPrice={totalPrice}
                      size='small'
                    /> */}
                  </center>

                  {/*<Tab className='payment-selector' defaultActiveIndex={0} panes={[
                { menuItem: 'PayPal', render: () => <Tab.Pane>
                  <Paypal {...paypalConfig} total={totalPrice/100} />
                </Tab.Pane> },

                { menuItem: 'Credit Card', render: () => <Tab.Pane>
                  <Form.Button onClick={buy} color='green' size='huge' className='rounded' fluid  {...{loading}}>
                  Pay with Card <Icon name='cc visa right' /><Icon name='cc mastercard right' /><Icon name='cc amex right' />
                  </Form.Button>
                </Tab.Pane> },


                { menuItem: 'Bitcoin', render: () => <Tab.Pane>
                  <a onClick={buyWithCrypto} className='buy-with-crypto'>
                    Pay with <Icon name='bitcoin' color='orange' /><i className='black text'>Bitcoin</i>
                  </a>
                </Tab.Pane> },
              ]} />*/}
                </React.Fragment>
              )}

              {err && (
                <Message icon negative size='mini'>
                  <Icon name='exclamation' />
                  <Message.Content>
                    <Message.Header>{err.response && err.response.data}</Message.Header>
                    <p>
                      Please try a different card.
                      <br /> Or use crypto: Bitcoin, ETH, USDC…
                    </p>
                  </Message.Content>
                </Message>
              )}

              <div className='fine-print'>
                <Icon name='warning sign left' color='orange' /> This site is a
                proof-of-concept. Not for official use.
                <br />
                <Icon name='check left' /> By proceeding you agree with our{' '}
                <Link to='/terms' target='_blank'>
                  Terms of Service
                </Link>
                .<br />
                <Icon name='check left' /> You'll be able to download your PDF right away.
                <br />
                <Icon name='lock' /> Secure payment guaranteed over HTTPS.
                <br />
                <Icon name='credit card outline' /> We never store your Credit Card
                details.
                <br />
                {showPNR ? (
                  <React.Fragment>
                    <br />
                    <Form.Input
                      label={
                        <small>
                          We don't recommend setting a PNR, because they can be easily
                          checked by officials. Set at your own risk:
                        </small>
                      }
                      placeholder='F7BM4V'
                      name='pnr'
                      size='small'
                      fluid
                      inline
                      onChange={handleChange}
                    />
                  </React.Fragment>
                ) : (
                  <a onClick={togglePNR}>
                    <Icon name='edit' color='grey' /> Need a PNR record?
                  </a>
                )}
                <br />
                <Icon name='currency' />
                &nbsp;Currency on the itinerary:&nbsp;
                <Dropdown
                  as='span'
                  search
                  pointing='top'
                  name='currencyCode'
                  onChange={handleChange}
                  defaultValue={currencyCode}
                  options={currencyOptions}
                />
              </div>
            </Form>
          </Grid.Column>
          <Grid.Column width={8}>
            <Form>
              <center>
                <div className='field'>
                  <label>Sample Confirmation:</label>
                </div>
              </center>
              <Link
                to={withPrefix('/FakeFlightTickets.com-SampleV2.pdf')}
                rel='noindex nofollow'
                target='_blank'>
                <div className='confirmation-example' />
              </Link>
            </Form>
          </Grid.Column>
        </Grid.Row>
      )
    } else {
      return null
    }
  }
}

export default FlightPreview



// WEBPACK FOOTER //
// ./src/components/FlightPreview.js